module.exports = __webpack_public_path__ + "img/chips10000.a89e5c79.webp";